import React from 'react'
import Card from '../../Components/card/Card'
import HomePage from './HomePage'

const HomeIFrame = () => {
  return (
    <Card component={<HomePage />} title={'Videos instructivos'} />
  )
}

export default HomeIFrame